module.exports = __webpack_public_path__ + "static/media/it_strategic6.b0a0c2d1.png";